// © Microsoft Corporation. All rights reserved.

export function fetchSignalR(callback: () => void) {
    const url = "https://assets.msn.com/labs/views/CommentWidget/js/signalr.min.js";
    const id = "signalR-jssdk";
    fetchScript(url, id, callback);
}

export async function fetchBlobClient(): Promise<AzureStorage> {
    const url = "https://assets.msn.com/labs/views/CommentWidget/js/azure-storage.blob.min.js";
    const id = "azure-storage-blob-jssdk";
    return new Promise((res, rej) => {
        if (window.AzureStorage) {
            return res(window.AzureStorage);
        }
        fetchScript(url, id, () => {
            if (window.AzureStorage) {
                return res(window.AzureStorage);
            }
            return rej();
        });
    });
}

function fetchScript(url: string, id: string, callback: () => void) {
    const d = document;
    const s = "script";
    if (!d.getElementById(id)) {
        const fjs = d.getElementsByTagName(s)[0];
        const js = d.createElement(s) as HTMLScriptElement; js.id = id;
        js.src = url;
        js.onload = callback;
        fjs.parentNode.insertBefore(js, fjs);
    }
}

export interface AzureStorage {
    Blob: Blob;
}

export interface Blob {
    createBlobServiceWithSas: (accountUrl: string, token: string) => BlobService;
}

export interface BlobService {
    createBlockBlobFromBrowserFile: (container: string, blobName: string, file: any, callback: (error, result, response) => void) => void;
}